import deviceService from '@/services/currentDeviceService';

const state = {
  currentDevice: null,
  timeout: {
    active: false,
    currentTimeout: 0
  },
  isTermsAndConditionsTrue: false,
  customFields: [],
};

const getters = {
  currentDevice: state => {
    return state.currentDevice;
  },
  currentLanguage: state => {
    return state.currentDevice?.defaultLocale;
  },
  isTermsAndConditionsTrue: state => {
    return state.isTermsAndConditionsTrue;
  },
  timeout: state => {
    return state.currentDevice?.timeout || 0;
  },
  currentTimeout: state => {
    return state.timeout.currentTimeout;
  },
  countDownTimer: (state, getters) => {
    //remove comment from next line in order to set up a custom timeout (for 10 seconds)
    //var countDownTimer = 10 - getters.currentTimeout;
    var countDownTimer = getters.timeout - getters.currentTimeout;
    if (countDownTimer > 0) {
      return countDownTimer;
    } else {
      return 0;
    }
  },
  timeoutActive: state => {
    return state.timeout.active;
  },
  showWarning: (state, getters) => {
    return false;
    //COMMENTED CODE: In case we want to show warning for timeout in the future, uncomment the code
    /*var secondsToShowWarning = 20;
    if (getters.timeoutActive == true) {
      return getters.countDownTimer > 0 && getters.countDownTimer <= secondsToShowWarning;
    } else {
      return false;
    }*/
  },
  chosenLocales: state => {
    return state.currentDevice?.chosenLocales
  },
  customFields: state => {
    return state.customFields
  },
};

const mutations = {
  setCurrentDevice(state, currentDevice) {
    state.currentDevice = currentDevice;
    this.$app.$locale(currentDevice?.defaultLocale);
  },
  setIsTermsAndConditionsTrue(state, isTermsAndConditionsTrue) {
    state.isTermsAndConditionsTrue = isTermsAndConditionsTrue
  },
  setTimeoutActive(state, timeoutActive = false) {
    state.timeout.active = timeoutActive;
  },

  // Change current timeout depending on the passed variable
  setCurrentTimeout(state, seconds) {
    state.timeout.currentTimeout = seconds;
  },
  incrementCurrentTimeout(state) {
    state.timeout.currentTimeout += 1;
  },
  setCustomFields(state, customFields) {
    state.customFields = customFields;
  },
};

const actions = {
  async initialize({ dispatch }) {
    await dispatch('getCurrentDevice');
  },
  async getCurrentDevice({ commit }) {
    try {
      const { data } = await deviceService.getCurrentDevice();
      commit('setCurrentDevice', data);
    } catch (e) {
      console.log(e);
    }
  },
  async setLanguage({ dispatch }, language) {
    try {
      await deviceService.setCurrentDeviceLanguage(language);
      dispatch('getCurrentDevice');
    } catch (e) {
      console.log(e);
    }
  },
  // Set global variable boolean value for if the user clicked the termsAndConditions checkbox
  setIsTermsAndConditionsTrue({ commit }, val = false) {
    commit('setIsTermsAndConditionsTrue', val);
  },
  enableTimeout({ dispatch, commit }) {
    commit('setTimeoutActive', true);
    dispatch('resetTimeout');
    // dispatch('timeout');
  },
  disableTimeout({ dispatch, commit }) {
    commit('setTimeoutActive', false);
    dispatch('resetTimeout');
  },
  resetTimeout({ commit }) {
    commit('setCurrentTimeout', 0);
  },
  incrementCurrentTimeout({ commit }) {
    commit('incrementCurrentTimeout');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};